import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { isEmpty } from 'lodash'

import { getCartItems } from '../../selectors/cart'

import { incrementNextOrderNumber, nextPosOrderNumber } from '../../utils/orderNumbers'

import createDataDogLog from '../../utils/datadog'

import { getOrderNumberMin, getOrderNumberMax } from '../Selectors'

// A module for managing invoice numbers for orders.
export const VNInvoiceManager = () => {
  const currentCartItems = useSelector(getCartItems)
  const cartIsEmpty = isEmpty(currentCartItems)

  const orderNumberMin = useSelector(getOrderNumberMin)
  const orderNumberMax = useSelector(getOrderNumberMax)

  // Avoid having a weird initial invoice number on first load.
  useEffect(() => {
    incrementNextOrderNumber()

    const currentInvoiceNumber = nextPosOrderNumber()

    createDataDogLog('info', 'Web application loaded - incrementing invoice number.', {
      currentInvoiceNumber,
      orderNumberMin,
      orderNumberMax,
    })
  }, [orderNumberMin, orderNumberMax])

  useEffect(() => {
    if (!cartIsEmpty) return

    incrementNextOrderNumber()

    const currentInvoiceNumber = nextPosOrderNumber()

    createDataDogLog('info', 'Cart cleared - incrementing invoice number.', {
      currentInvoiceNumber,
    })
  }, [cartIsEmpty])

  return <></>
}
